import { JsaForm, UuidAndIdAndJsaForms } from "../models/jsa.model";
import { JsaFormStateModel } from "../state/jsa-form.state";
import { UuidAndId } from '../models/uuid-and-id';

export namespace JsaFormActions {
    export class Refresh {
        static readonly type = '[API-JsaForm] Refresh'
        constructor() {}
    }
    export class IncrementPendingCount {
        static readonly type = '[Network Service-JsaForm] Increment Pending Count'
        constructor() {}
    }    
    export class AddOne {
        static readonly type = '[UI-JsaForm] Add One'
        constructor(public payload: JsaForm) {}
    } 
    export class UpdateOne {
        static readonly type = '[UI-JsaForm] Update One'
        constructor(public payload: JsaForm) {}
    }
    export class ApiAddedOne {
        static readonly type = '[API-JsaForm] Added One'
        constructor(public payload: UuidAndIdAndJsaForms) {}
    }
    export class ApiUpdatedOne {
        static readonly type = '[API-JsaForm] Updated One'
        constructor(public payload: UuidAndIdAndJsaForms) {}
    }
    export class DeleteOne {
        static readonly type = '[UI-JsaForm] Delete One'
        constructor(public payload: JsaForm) {}
    }  
    export class ApiDeletedOne {
        static readonly type = '[API-JsaForm] Deleted One'
        constructor(public payload: UuidAndId) {}
    }
    export class AddMany {
        static readonly type = '[API-JsaForm] Add Many'
        constructor(public payload: JsaForm[]) {}
    }
    export class Init {
        static readonly type = '[API-JsaForm] Init'
        constructor(public payload: JsaFormStateModel) {}
    }
    export class Set {
        static readonly type = '[API-JsaForm] Set'
        constructor(public payload: JsaForm[]) {}
    }
    export class Merge {
        static readonly type = '[API-JsaForm] Merge'
        constructor(public payload: JsaForm[]) {}
    }
}
